import React from 'react';
import MaterialIcon from "./MaterialIcon.jsx";

/**
 * A rounded search box with a magnifying glass (css/_search_input.scss). `onChange` gets the text,
 * not the event. `className` is for sizing it where it sits; the look stays the same everywhere.
 */
export default function SearchInput({ value, onChange, placeholder = 'Search', className = '', ...inputProps }) {
	return (
		<label className={`search_input ${className}`.trim()}>
			<MaterialIcon>search</MaterialIcon>
			<input
				type='search'
				className='browser-default'
				placeholder={placeholder}
				aria-label={placeholder}
				autoComplete='off'
				value={value}
				onChange={(event) => onChange(event.target.value)}
				{...inputProps}
			/>
		</label>
	);
}
